export const validateLoginForm = (username, password) => {
  let errors = {};

  if (!username) {
    errors.username = '아이디 값을 입력해주세요';
  }

  if (!password) {
    errors.password = '비밀번호 값을 입력해주세요';
  }

  return errors;
};

export const validateInviteUserForm = (store, name, email) => {
  const emailRegex =
    /^(([^<>()\[\].,;:\s@"]+(\.[^<>()\[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
  let errors = {};

  if (!emailRegex.test(email)) {
    errors.email = '유효한 이메일을 입력해주세요';
  }

  if (name.length > 10) {
    errors.name = '이름은 10자 이하로 입력해주세요';
  }

  if (!email) {
    errors.email = '이메일을 입력해주세요';
  }

  if (!name) {
    errors.name = '이름을 입력해주세요';
  }

  if (!store) {
    errors.store = '소속을 입력해주세요';
  }

  return errors;
};

export const validatePassword = (password, passwordConfirm) => {
  const regExp = /^(?=.*\d)(?=.*[a-zA-Z])[0-9a-zA-Z]{8,10}$/;
  let errors = {};

  if (!regExp.test(passwordConfirm)) {
    errors.passwordConfirm = '8 ~ 10자 영문, 숫자 조합으로 입력해주세요';
  }

  if (!regExp.test(password)) {
    errors.password = '8 ~ 10자 영문, 숫자 조합으로 입력해주세요';
  }

  if (password !== passwordConfirm) {
    errors.passwordConfirm = '비밀번호 재입력이 일치하지 않습니다';
  }

  if (!passwordConfirm) {
    errors.passwordConfirm = '비밀번호 재입력을 입력해주세요';
  }

  if (!password) {
    errors.password = '비밀번호를 입력해주세요';
  }

  return errors;
};

export const validatePhoneNumber = phoneNumber => {
  var regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
  let error = {};

  if (!regPhone.test(phoneNumber)) {
    error = '올바른 번호를 적어주세요';
  }

  if (!phoneNumber) {
    error = '연락처를 입력해주세요';
  }

  return error;
};

export const validatePlaceInputs = (
  name = '',
  address = '',
  detailAddress = '',
) => {
  let errors = {};

  if (!detailAddress) {
    errors.detailAddress = '상세주소를 입력해주세요';
  }

  if (!address) {
    errors.address = '주소를 입력해주세요';
  }

  if (!name) {
    errors.name = '매장명을 입력해주세요';
  }

  return errors;
};

export const validateContractRegisterForm = ({
  edit,
  company,
  code,
  name,
  tel,
  userId,
  password,
  passwordConfirm,
  username,
  team,
  position,
  userTel,
  email,
}) => {
  var regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
  const regPassword = /^(?=.*\d)(?=.*[a-zA-Z])[0-9a-zA-Z]{8,10}$/;
  const regEmail =
    /^(([^<>()\[\].,;:\s@"]+(\.[^<>()\[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
  let errors = {};

  if (!regEmail.test(email)) {
    errors.email = '유효한 이메일을 입력해주세요';
  }

  if (!regPhone.test(userTel)) {
    errors.userTel = '올바른 번호를 적어주세요';
  }

  if (!edit && password !== passwordConfirm) {
    errors.passwordConfirm = '비밀번호 재입력이 일치하지 않습니다';
  }

  if (!edit && !regPassword.test(passwordConfirm)) {
    errors.passwordConfirm = '8 ~ 10자 영문, 숫자 조합으로 입력해주세요';
  }

  if (!edit && !regPassword.test(password)) {
    errors.password = '8 ~ 10자 영문, 숫자 조합으로 입력해주세요';
  }

  if (!regPhone.test(tel)) {
    errors.tel = '올바른 번호를 적어주세요';
  }

  if (!email) {
    errors.email = '이메일을 입력해주세요';
  }

  if (!userTel) {
    errors.userTel = '연락처를 입력해주세요';
  }

  if (!position) {
    errors.position = '직급을 입력해주세요';
  }

  if (!team) {
    errors.team = '부서를 입력해주세요';
  }

  if (!username) {
    errors.username = '사용자 이름을 입력해주세요';
  }

  if (!edit && !passwordConfirm) {
    errors.passwordConfirm = '비밀번호 재확인을 입력해주세요';
  }

  if (!edit && !password) {
    errors.password = '비밀번호를 입력해주세요';
  }

  if (!userId) {
    errors.userId = 'Master ID를 입력해주세요';
  }

  if (!tel) {
    errors.tel = '계약자 연락처를 입력해주세요';
  }

  if (!name) {
    errors.name = '계약자를 입력해주세요';
  }

  if (!code) {
    errors.code = 'SI코드를 입력해주세요';
  }

  if (!company) {
    errors.company = '회사명을 입력해주세요';
  }

  return errors;
};

export const validateMasterKidRegisterForm = (userId, password) => {
  const regPassword = /^(?=.*\d)(?=.*[a-zA-Z])[0-9a-zA-Z]{8,10}$/;
  let errors = {};

  if (!regPassword.test(password)) {
    errors.password = '8 ~ 10자 영문, 숫자 조합으로 입력해주세요';
  }

  if (!password) {
    errors.password = '비밀번호를 입력해주세요';
  }

  if (!userId) {
    errors.userId = 'ID를 입력해주세요';
  }

  return errors;
};

export const validatePlanUploader = (name, selectedFile, replace) => {
  let errors = {};

  if (!selectedFile) {
    errors.selectedFile = '파일을 선택해주세요';
  }

  if (!name && !replace) {
    errors.name = '공간을 입력해주세요';
  }

  return errors;
};

export const validateStoreCreator = (code, tel) => {
  var regPhone = /^([0-9]{2,3})-?([0-9]{3,4})-?([0-9]{4})$/;
  let errors = {};

  if (!regPhone.test(tel)) {
    errors.tel = '올바른 번호를 적어주세요';
  }

  if (!tel) {
    errors.tel = '전화번호를 입력해 주세요';
  }

  if (!code) {
    errors.code = '코드를 입력해 주세요';
  }

  return errors;
};
